import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// import axios from '@/request/http.js'  //导入http中创建的axios实例
//路由地址
import home from '@/views/home/index'
import list from '@/views/list/index'
import detail from '@/views/detail/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
	meta: {
		title: '首页'
	}
  },
  {
    path: '/list',
    name: 'list',
    component: list,
	meta: {
		title: '列表'
	}
  },
  {
    path: '/detail',
    name: 'detail',
    component: detail,
	meta: {
		title: '详情'
	}
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next) => {
	next()
})

export default router
